export default "__VITE_ASSET__a6fb53cb__"